require('./cardStatementMovementsTableRow.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');
// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class CardStatementMovementsTableRow extends React.Component {
    render() {
        const {
            id,
            immScreen,
            immTransaction,
        } = this.props;
        const plainAmountObject = getPlainAmountObject(immTransaction.get('import'));
        const language = getLanguage();
        const isMobile = immScreen.get('isMobile');
        const date = (
            <LabelDate
                date={immTransaction.get('date')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        );

        const amountClasses = classNames(
            {'card-statement-movements-table-row__detail-mobile-primary' : isMobile}
        );

        const amount = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                className={amountClasses}
            />
        );

        let tableRow;

        if (isMobile) {
            tableRow = (
                <OKTableRow id={id} >
                    <OKTableCell>
                        <p className="card-statement-movements-table-row__detail-mobile-primary">
                            {date}
                        </p>
                        <p className="card-statement-movements-table-row__detail-mobile-secondary">
                            <FormattedText
                                value="cardStatementMovements-hourLabel"
                                injectedStrings={[immTransaction.get('hour')]}
                            />
                        </p>
                        <p className="card-statement-movements-table-row__detail-mobile-secondary">
                            {immTransaction.get('commerce')}
                        </p>
                        <p className="card-statement-movements-table-row__detail-mobile-secondary">
                            {immTransaction.get('cardNumber')}
                        </p>

                    </OKTableCell>
                    <OKTableCell className="card-statement-movements-table-row__right-mobile-cell">
                        {amount}
                    </OKTableCell>
                </OKTableRow>
            );
        } else {
            tableRow = (
                <OKTableRow id={id} >
                    <OKTableCell>
                        {date}
                    </OKTableCell>
                    <OKTableCell>
                        <FormattedText
                            value="cardStatementMovements-hourLabel"
                            injectedStrings={[immTransaction.get('hour')]}
                        />
                    </OKTableCell>
                    <OKTableCell>
                        {immTransaction.get('commerce')}
                    </OKTableCell>
                    <OKTableCell>
                        {immTransaction.get('cardNumber')}
                    </OKTableCell>
                    <OKTableCell className="card-statement-movements-table-row__import">
                        {amount}
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }
}

CardStatementMovementsTableRow.propTypes = {
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
};

module.exports.constructor = CardStatementMovementsTableRow;
module.exports = connect(
    state => ({
        immScreen: state.screen,
    }),
    null)(CardStatementMovementsTableRow);
